import s from './popUp.module.css';
import turnoff from '../../../img/turnoff.svg';


const PopUp = (props) => {
    return (
        <div className={s.popup}>
            <div className={s.back} onClick={() => props.togglePopUp(false)}>
            </div>
            <div className={s.text}>
                <div className={s.turnoff}><img src={turnoff} alt="" onClick={() => props.togglePopUp(false)}/></div>
                <p>{props.text}</p>
            </div>
        </div>
    )
}

export default PopUp;